import Select, { MultiValue } from 'react-select';
import useProxyPoolCreationForm from '../../store/proxyPoolCreationFormStore';
import static_cities from '@/model/static_cities';

type CityOptionType = {
  value: string;
};

export default function CitySelect() {
  const { country, cities, setCities } = useProxyPoolCreationForm();

  const handleChange = (options: MultiValue<CityOptionType> | null) => {
    if (options !== null) setCities(options.map((i) => i.value));
  };

  return (
    <Select
      value={cities.map((c) => ({ value: c }))}
      onChange={handleChange}
      getOptionLabel={(o) => o.value}
      options={
        static_cities[country.countryCode as keyof typeof static_cities]
      }
      placeholder="Select cities (optional)"
      isMulti
    />
  );
}
